var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00ADED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67957 13.2767L5.68069 13.2745L7.47394 8.99047L5.67957 4.70703L8.98988 8.99047L5.68182 13.2739L5.67957 13.2767ZM12.3036 13.2767L12.3013 13.2739L8.99325 8.99047L12.3036 4.70703L10.5092 8.99047L12.3024 13.2745L12.3036 13.2767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99156 8.99108V11.9757L5.67844 13.2751L8.99156 8.98883V6.00421L12.3047 4.70483L8.99156 8.99108Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99156 11.9756V14.5918L5.67844 13.2733L8.99156 11.9711V8.991L5.67844 4.70475L8.99156 6.00413V3.38794L12.3047 4.70588L8.99156 6.00806V8.98875L12.3047 13.275L8.99156 11.9756Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67844 4.70588L8.99156 3.38794V6.00806L5.67844 4.70588ZM12.3047 13.2733L8.99156 14.5918V11.9711L12.3047 13.2733Z",
    fill: "white",
    fillOpacity: 0.145
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElix);
export default __webpack_public_path__ + "static/media/elix.b8238f4c16b0a6d5398a38f6b3836224.svg";
export { ForwardRef as ReactComponent };